<section class="section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'date')" [(ngModel)]="billDate">
                        <option selected disabled value="">Select Bill Date</option>
                        <option value="all">All</option>
                        <option *ngFor="let date of this.billDateDetails">{{date}}</option>
                    </select>
                    <label for="floatingSelect">Bill Date</label>
                </div>
            </div>

            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'status')" [(ngModel)]="billTypes">
                        <option selected disabled value="">Select Bill Type</option>
                        <option value="all">All</option>
                        <option *ngFor="let status of this.billTypeDetails">{{status}}</option>
                    </select>
                    <label for="floatingSelect">Bill Type</label>
                </div>
            </div>

            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
                    <label class="text-gray">Search</label>
                </div>
            </div>

            <div class="col-lg col-md-3 mt-2 d-flex justify-content-end">
                <button class="btn btn-danger mt-2" (click)="resetReviewFilter()">Clear Filters <img class="img-fluid"
                        alt="clear" src="assets/img/icons/clear-alt.png"></button>
            </div>
        </div>


        <div class="mt-3"></div>
        <div class="row">
            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date" id="fromDate" class="form-control" (change)="onDate()">
                    <label for="fromDate">From Date:</label>
                </div>
            </div>
            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date" id="toDate" class="form-control" (change)="onDate()">
                    <label for="toDate">To Date:</label>
                </div>
            </div>
            <div class="col-lg col-md-3 mt-2"></div>

            <div class=" col -lg col-md-3 mt-2 d-flex justify-content-end">
                <button class="btn btn-success mt-2 me-3">Download Excel <i
                        class="bi bi-file-earmark-excel"></i></button>
                <button class="btn btn-primary mt-2">Download PDF <i
                        class="fa-solid fa-file-pdf"></i>
                </button>
            </div>

        </div>


        <div class="py-2"></div>


        <div class="container-fluid">
            <div class="table-style table-responsive table-bordered">
                <table class="table table-head-fixed text-nowrap text-center">
                    <thead>
                        <tr class="sticky-top">
                            <th>S.No</th>
                            <th>Customer Name</th>
                            <th>Phone Number</th>
                            <th>City</th>
                            <th>Bill Date</th>
                            <th>Bill Type</th>
                            <th>Total Amount</th>
                            <th>Print</th>
                        </tr>
                    </thead>
                    <tbody class="text-center"
                        *ngIf="(shopBillDetails | filter:searchText).length > 0; else noDataFound">
                        <tr *ngFor="let item of this.shopBillDetails | filter: searchText; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item?.customerName || "-"}}</td>
                            <td>{{item?.phoneNumber || "-"}}</td>
                            <td>{{item?.city || "-"}}</td>
                            <td>{{item?.createdAt | date : "dd-MM-yyy / hh:mm:ss aa"}}</td>
                            <td>{{item?.billType || "-"}}</td>
                            <td>{{ getFormattedAmount (item?.totalAmount) || "-" }}</td>
                            <td>
                                <button class="btn btn-md btn-info text- rounded-pill"
                                    (click)="printBill(item?.billId,item?.billType)">Print <i
                                        class="fas fa-print"></i></button>
                            </td>
                        </tr>
                    </tbody>
                    <ng-template #noDataFound>
                        <tr class="text-center ubuntu-bold h6 text-danger">
                            <td colspan="12">Data Not Found</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>
</section>